import React, { Component } from "react";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../principal/containers/DataWrapper";
import ModalForm from "../../comum/components/ModalForm";
import ModalAviso from "../../comum/components/ModalAviso";
import CargaGeralStore from "../stores/CargaGeralStore";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import FooterOptions from "../../comum/components/FooterOptions";
import IconButton from "../../comum/components/IconButton";
import { makePDF } from "../../../utils/formatar";
import _ from "lodash";
import FiltrosCargaGeral from "../components/FiltrosCargaGeral";
import { TabelaCargaGeral } from "../components/TabelaCargaGeral";
import ExportarExcelCargaGeral from "../components/ExportarExcelCargaGeral";
import AgendamentoCargaGeralService from "../../../services/AgendamentoCargaGeralService";
import { CargaGeralImportaXLS } from "../components/CargaGeralImportaXLS";
import { TabelaCargaGeralNova } from "../components/TabelaCargaGeralNova";
import { CargaGeralCadastrar } from "../components/CargaGeralCadastrar";
import { IconeCarregar } from "../../comum/components/Icones";
import ModalAvisoCargaGeral from "../../comum/components/ModalAvisoCargaGeral";
import { ModalContainer, ModalDialog } from "react-modal-dialog";

@inject("store")
@DataWrapper
@observer
export class CargaGeral extends Component {
  constructor(props) {
    super(props);
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;

    this.service = new AgendamentoCargaGeralService();
    this.controller = new CargaGeralStore(this.service);
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("Carga Geral");
    this.controller.carregarDadosNavio();
    this.controller.carregarDadosNavioAgend();

    let voltarParam = _.get(this.props.location.state, `voltar`);
    this.props.store.appStore.showVoltarTopBar(
      voltarParam ? true : false,
      voltarParam ? voltarParam : "/"
    );
  }

  componentDidUpdate() {
    this.aviso();
  }

  CargaGeralCadastrar = () => {
    if (this.controller.inserindo)
      return (
        <CargaGeralCadastrar
          controller={this.controller}
          service={this.service}
        />
      );
  };


  modalCarregarXLS() {
    if (this.controller.inserindoXls)
      return (
        <CargaGeralImportaXLS
          controller={this.controller}
          service={this.service}
        />
      );
  }

  modalConfirmaInativar = () => {
    if (this.controller.modalInativar)
      return (
        <ModalForm
          labelCancelar="NÃO"
          labelConfirmar="SIM"
          salvando={this.controller.inativandoLoading}
          onClickCancelar={() => this.controller.cancelaInativar()}
          onClickSalvar={() => this.controller.confirmarInativar()}
        >
          {this.controller.selecionados.length === 1 ? (
            <h2>Deseja inativar sua liberação?</h2>
          ) : (
            <h2>
              Deseja inativar as {this.controller.selecionados.length}{" "}
              liberações?
            </h2>
          )}
        </ModalForm>
      );
  };

  aviso = () => {
    if (this.controller.listaMensagens)
      return (
        <ModalAvisoCargaGeral
          onClickFechar={() => (this.controller.listaMensagens = false)}
        >
          {this.controller.listaMensagens.map((msg, x) => (
            <h2 key={x}>{msg}</h2>
          ))}
        </ModalAvisoCargaGeral>
      );
  };

  inserindoNovas = () => {
    return this.controller.novasCargas.length > 0;
  };

  render() {
    const msgSelecionadas =
      this.controller.selecionados.length === 1
        ? "Liberação selecionada"
        : "Liberações selecionadas";
    let pdfData = this.controller.colunasExportacao;
    return (
      <div className="form-wrapper">
        {this.aviso()}
        {this.modalConfirmaInativar()}
        {this.modalCarregarXLS()}
        {this.CargaGeralCadastrar()}

        <Container
          className="liberacao-cabotagem tela-botoes-inclusao-topo"
          fluid
        >
          <Row className="botoes-inclusao-topo">
            <Col xs={12} sm={12} md={12}>
              <Button
                onClick={() => (this.controller.inserindo = true)}
                className="btn-com-bordas-primary"
              >
                Nova Liberação
              </Button>
              <Button
                onClick={() => (this.controller.inserindoXls = true)}
                className="btn-com-bordas-cinza"
              >
                Importar Planilha
              </Button>
            </Col>
          </Row>
          <FiltrosCargaGeral controller={this.controller} />
          {this.inserindoNovas() ? (
            <TabelaCargaGeralNova controller={this.controller} />
          ) : (
            <TabelaCargaGeral controller={this.controller} />
          )}
        </Container>
        {!this.inserindoNovas() && (
          <Footer>
            <FooterContent>
              <div className="justify-content-between">
                {this.controller.selecionados.length > 0 ? (
                  <div>
                    <b>{this.controller.selecionados.length}</b>{" "}
                    {msgSelecionadas}
                  </div>
                ) : (
                  <div>
                    <b>{this.controller.itens.length}</b> Registros no Total
                    {this.controller.estadoFiltros && (
                      <React.Fragment>
                        -{" "}
                        <a onClick={() => this.controller.reListar()}>
                          Atualizar Lista
                        </a>
                      </React.Fragment>
                    )}
                  </div>
                )}
              </div>
            </FooterContent>
            <FooterOptions>
              <div>
                {this.controller.selecionados.length > 0 ? (
                  <IconButton
                    icon="file-pdf"
                    text="Baixar PDF"
                    size="md"
                    disabled={this.controller.selecionados.length === 0}
                    onClick={() => {
                      // Cria uma cópia da lista de selecionados
                      const selecionadosFormatados =
                        this.controller.selecionados.map((carga) => {
                          // Verifica e formata o campo "DataCancelamento"
                          return {
                            ...carga,
                            DataCancelamento:
                              carga.DataCancelamento &&
                              carga.DataCancelamento.startsWith("0001")
                                ? ""
                                : carga.DataCancelamento,
                          };
                        });

                      // Chama a função makePDF com a lista formatada
                      makePDF(
                        selecionadosFormatados,
                        pdfData.map((elem) => elem.dataField),
                        pdfData.map((elem) => elem.text),
                        [],
                        true,
                        false,
                        { qtdColFixo: "A2", nomeDoArquivo: "CargasGerais.pdf" }
                      );
                    }}
                  />
                ) : (
                 
                  <IconButton
                    icon="file-pdf"
                    text="Baixar PDF"
                    size="md"
                    disabled={this.controller.cargasLista.length === 0}
                    onClick={() => {
                      // Cria uma cópia da lista de cargas
                      const cargasListaFormatada =
                        this.controller.cargasLista.map((carga) => {
                          // Verifica e formata o campo "DataCancelamento"
                          return {
                            ...carga,
                            DataCancelamento:
                              carga.DataCancelamento &&
                              carga.DataCancelamento.startsWith("0001")
                                ? ""
                                : carga.DataCancelamento,
                          };
                        });

                      // Chama a função makePDF com a lista formatada
                      makePDF(
                        cargasListaFormatada,
                        pdfData.map((elem) => elem.dataField),
                        pdfData.map((elem) => elem.text),
                        [],
                        true,
                        false,
                        { qtdColFixo: "A2", nomeDoArquivo: "CargasGerais.pdf" }
                      );
                    }}
                  />
                
                )}
              </div>
              <div>
                <ExportarExcelCargaGeral controller={this.controller} />
              </div>
            </FooterOptions>
            <FooterContent className="right-pos">
              <div>
                {!this.controller.salvando ? (
                  <Button
                    disabled={this.controller.selecionados.length === 0}
                    className="btn-primary"
                    onClick={() => this.controller.abrirModalInativar()}
                  >
                    INATIVAR LIBERAÇÃO
                  </Button>
                ) : (
                  <IconeCarregar tamanho="2x" cor="#001C43" />
                )}
              </div>
            </FooterContent>
          </Footer>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/telas/cargaGeral.js